import __request__ from "routing/request";
export function permissions(requestOptions) {
  return __request__("GET", "/system/permissions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function readerPermissions(username, requestOptions) {
  return __request__("GET", `/system/permissions/reader/${username}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
